
import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'

import 'swiper/scss'

import map from 'lodash/map'
import uniqBy from 'lodash/uniqBy'
import get from 'lodash/get'
import split from 'lodash/split'

import classNames from 'classnames'

import styles from './resources_carousel.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import Button from './basic/button'
import Link from './basic/link'
import ScrollAnimation from './layout/scroll_animation'

function ResourcesCarousel(props) {
	const sliderRef = useRef(null)
	const fields = props.fields
	const [carouselSlides, setCarouselSlides] = useState(null)
	const [carouselItems, setCarouselItems] = useState(fields.items.map(obj => ({ ...obj, buttonActive: false })))
	const [activeCategory, setActiveCategory] = useState(null)

	const categories = uniqBy(map(uniqBy(fields.items, (item) => item.category), function (item) {
		let i, categories = split(item.category, ',')

		for (i = 0; i < categories.length; i++) {
			return categories[i].trim()
		}
	}))

	const sliderConfig = {
		modules: [Navigation],
		spaceBetween: 20,
		slidesPerView: 3,
		slidesPerGroup: 3,
		loop: false,
		watchSlidesProgress: true,
		navigation: {
			prevEl: `.${styles.previous}`,
			nextEl: `.${styles.next}`,
			clickable: true
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 10
			},
			900: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1240: {
				slidesPerView: 3,
				spaceBetween: 20
			},
		}
	}

	const handleMouseEvent = (index) => {
		setCarouselItems(
			carouselItems.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	useEffect(() => {
		setCarouselSlides([...get(sliderRef, 'current.swiper.slides', [])])
	}, [])

	useEffect(() => {
		if(sliderRef.current && carouselSlides){
			let slider = sliderRef.current.swiper
			let filteredSlides = activeCategory ? carouselSlides.filter((slide) => slide.getAttribute('data-category').indexOf(activeCategory) > -1) : carouselSlides

			slider.slides.forEach((slide) => slide.remove())

			filteredSlides.forEach((slide) => {
				slider.el.childNodes[0].appendChild(slide)
			})

			slider.update()
		}
	}, [activeCategory])

	useEffect(() => {
		function onResize() {
			if (window.innerWidth < 768 && carouselItems.length <=3 ) {
				sliderRef.current.swiper.disable()
			}
		}

		window.addEventListener('resize', onResize)

		onResize()

		return () => window.removeEventListener('resize', onResize)
	}, [])

	const buttonColors = {
		default: 'green',
		purple: 'purple',
	}

	return <BlockWrapper {...props} className={styles.resources_carousel}>
		<ScrollAnimation styles={styles}>
			{categories.length > 1 && 
				<div className={styles.filter_wrapper}>
					<span className={styles.h3}>Filter By:</span>
					<div className={styles.filter}>
					{categories.map((category, i) => {
						return <button key={i} className={classNames(styles.h3, styles.option, activeCategory == category ? styles.active : '')} onClick={() => setActiveCategory(category)}>{category}</button>
					})}
					</div>
				</div>
			}
			<div className={classNames(styles.carousel_wrapper, carouselItems.length <=3 ? styles.no_arrows : styles.has_arrows)}>
				<button aria-label='previous' className={styles.previous}></button>
				<Swiper ref={sliderRef} className={classNames(props.editor ? styles.in_editor : '', styles.carousel)} {...sliderConfig}>
					{carouselItems && carouselItems.map((item, index) => {
						return <SwiperSlide 
							onMouseEnter={() => handleMouseEvent(index)}
							onMouseLeave={() => handleMouseEvent()}
							className={classNames(styles.carousel_item, item.icon ? styles.with_icon : '')} 
							key={index}
							data-category={item.category}
						>
							<Link href={item.button.url} target={item.button.target}>
								<div className={styles.cardContainer}>
									{item.logo ? <Image {...item.logo} className={styles.logo} /> : null}
									{item.icon && <Image {...item.icon} className={styles.icon}/>}
									<h2 className='h3'>{item.title}</h2>
									<div className={styles.content} dangerouslySetInnerHTML={{ __html: item.content}} />
								</div>
								<Button className={styles.button} color={buttonColors[item.button_color]} active={item.buttonActive}>{item.button.title}{item.logo ? <Image {...item.logo} className={styles.buttonLogo} /> : null}</Button>
							</Link>
						</SwiperSlide>
						
					})}
				</Swiper>
				<button aria-label='next' className={styles.next}></button>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default ResourcesCarousel